import React from 'react';
import { Button } from '@themesberg/react-bootstrap';
import Datetime from 'react-datetime';
import { useSelector, useDispatch } from 'react-redux';
import {
  initialDateFilterChanged,
  selectInitialDate,
} from '../../features/incidents/incidents.dateFilters.slice';
import { formatDate } from '../../utils/reusableFunctions';

const InitialDateFilter = () => {
  const dispatch = useDispatch();
  const initialDate = useSelector(selectInitialDate);

  return (
    <Datetime
      timeFormat={false}
      onChange={(date) => dispatch(initialDateFilterChanged(date))}
      value={formatDate(initialDate, '-')}
      initialValue={formatDate(initialDate, '-')}
      renderInput={(props, openCalendar, closeCalendar) => (
        <Button
          onClick={openCalendar}
          className='primary p-3'
        >
          <small>{`FROM: ${formatDate(initialDate, '-')}`}</small>
        </Button>
      )}
    />
  );
};

export default InitialDateFilter;
